module.exports = __webpack_public_path__ + "static/img/el-icon-my-whatsapp.37ad6fa.png";